import styles from "../../styles/Components/pricing-plan/Referrals.module.css";
import {
  FaCreditCard,
  FaUserFriends,
  FaUsers,
} from "react-icons/fa";
import WithdrawButton from "./referrals/WithdrawButton";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import { useState } from "react";
import InviteFriendsModal from "../mini-app/mini-pricing/InviteFriendsModal";
import ReferredUsers from "./individual-services/ReferredUsers";
import { HiOutlineBadgeCheck, HiOutlineClipboardList } from "react-icons/hi";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { LuPartyPopper } from "react-icons/lu";
import useFetchReferralRewards from "../../hooks/api/useFetchReferralRewards";
import usePageTitle from "../../hooks/usePageTitle";

function Referrals() {
  const {
    pricingPlan: { referralRewardsLoading, referralRewards },
  } = useSelector((state) => state);

  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const totalMoney = referralRewards?.reduce(
    (acc, cur) => Number(cur?.cashable_reward) + acc,
    0,
  );

  useFetchReferralRewards();
  usePageTitle("Referral Earnings");

  return (
    <div className={styles.container}>
      <h4 className={styles.title}>Referral Earnings</h4>
      <div className={styles.sectionsContainer}>
        {/* Overview Section */}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <HiOutlineClipboardList /> Overview
          </div>
          <div className={`${styles.summaryBox} ${styles.sectionBox}`}>
            <div className={styles.info}>
              <span className={styles.infoTitle}>
                <FaUserFriends /> Number of friends
              </span>
              <span className={styles.infoValue}>
                {referralRewardsLoading ? (
                  <Skeleton.Node rootClassName={styles.loader} active />
                ) : (
                  referralRewards?.length || 0
                )}
              </span>
            </div>

            <div className={styles.info}>
              <span className={styles.infoTitle}>
                <FaCreditCard /> Total earned moneys
              </span>
              <span className={styles.infoValue}>
                {referralRewardsLoading ? (
                  <Skeleton.Node rootClassName={styles.loader} active />
                ) : (
                  totalMoney || 0
                )}
              </span>
            </div>

            <WithdrawButton
              style={{ marginTop: ".5rem" }}
              className={styles.withdrawBtn}
            />
            <div
              className={styles.linkBtn}
              onClick={() => setShowInvitationModal(true)}
            >
              Invite & Refer
            </div>
          </div>
        </div>

        {/* Earn Cash Section */}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <FaHandHoldingDollar /> Earn Cash
          </div>
          <div className={`${styles.earnCashContent} ${styles.sectionBox}`}>
            <div className={styles.earnCashHeader}>
              <LuPartyPopper /> Refer Friends: Earn Cash!
            </div>
            <div className={styles.earnCashSubtext}>
              <HiOutlineBadgeCheck /> Earn 10-40% cash commission
            </div>

            <div className={styles.howItWorks}>
              <h4>How It Works</h4>

              <div className={styles.step}>
                <div className={styles.stepNumber}>1</div>
                <div className={styles.stepText}>
                  Get your unique referral link via the Invite & Refer button.
                </div>
              </div>

              <div className={styles.step}>
                <div className={styles.stepNumber}>2</div>
                <div className={styles.stepText}>
                  Share the link with friends, colleagues, or your audience.
                </div>
              </div>

              <div className={styles.step}>
                <div className={styles.stepNumber}>3</div>
                <div className={styles.stepText}>
                  Your friend gets 50% off their first paid plan. You earn 10%
                  cash per referral until you reach 100 paying users - then earn
                  40% per referral from the 101st onward
                </div>
              </div>
            </div>

            <div
              className={styles.linkBtn}
              onClick={() => setShowInvitationModal(true)}
            >
              Invite & Refer
            </div>
          </div>
        </div>

        {/* Referred Users Section */}
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <FaUsers /> Referred Users
          </div>
          <div
            className={`${styles.referredUsersContent} ${styles.sectionBox}`}
          >
            <ReferredUsers />
          </div>
        </div>
      </div>

      {showInvitationModal && (
        <InviteFriendsModal
          show={showInvitationModal}
          setShow={setShowInvitationModal}
        />
      )}
    </div>
  );
}

export default Referrals;
